<template>
    <div class="container">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Lista de Sinistros Cobrança</h4>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="gp-claim-status-toolbar">
                                    <button v-for="situacao in situacoesAtalho" :key="situacao.valor" type="button"
                                        class="gp-claim-status-button" :class="{ 'is-active': situacaoSelecionada === situacao.valor }"
                                        @click="SelecionaSituacao(situacao.valor)">{{ situacao.nome }}</button>
                                </div>
                                <v-row>
                                </v-row>
                                <adm-data-table v-if="ListSinistros!=''" :headers="gridHeaders" :export-headers="headers"
                                    :filter-source-headers="headers" :filter-columns="4" :items="ListSinistros"
                                    v-model="itemsSelected" alternating theme-color="#364f66"
                                    table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina"
                                    file-name="sinistros-cobranca"
>
                                    <template #item-entidadesResumo="item">
                                        <div class="gp-claim-entity-summary">
                                            <strong>{{ item.garNome || '—' }}</strong>
                                            <small>{{ item.imoNome || '—' }}</small>
                                        </div>
                                    </template>
                                    <template #item-pedDescricao="item">
                                        <div class="gp-claim-client-summary">
                                            <strong>{{ separarCliente(item.pedDescricao).nome }}</strong>
                                            <small v-if="separarCliente(item.pedDescricao).documento">{{ separarCliente(item.pedDescricao).documento }}</small>
                                        </div>
                                    </template>
                                    <template #item-sncDtInclusao="item">
                                        <span> {{ item.sncDtInclusao !== null ? formattedDate(item.sncDtInclusao) : null }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <div class="gp-table-actions">
                                            <button type="button" class="gp-table-action gp-action-edit" title="Abrir cobrança"
                                                @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button>
                                        </div>
                                    </template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'

export default {
    name: 'ListaSinistrosCobrancaView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
         User: {
            garid:0,
            tpeid:0,
        },
        itemsSelected: [],
        searchValue: '',
        MostraGrid: true,
        headers: [],
        ListSinistros:[],
        ListSinistrosGeral:[],
        situacaoSelecionada: 0,
        situacoesAtalho: [
            { nome: 'Aguardando aprovação', valor: 20 },
            { nome: 'Todos', valor: 0 }
        ],
    }),
    computed: {
        gridHeaders() {
            const resultado = [];
            let entidadesIncluidas = false;
            this.headers.forEach(header => {
                if (header.value === 'garNome' || header.value === 'imoNome') {
                    if (!entidadesIncluidas) {
                        resultado.push({ text: 'Garantidora / Imobiliária', value: 'entidadesResumo', sortable: false });
                        entidadesIncluidas = true;
                    }
                } else resultado.push(header);
            });
            return resultado;
        }
    },
    methods: {
        separarCliente(valor) {
            const texto = String(valor || '').trim();
            const partes = texto.split(' - ');
            if (partes.length < 2) return { nome: texto || '—', documento: '' };
            return { nome: partes.shift(), documento: partes.join(' - ') };
        },
        SelecionaSituacao(value){
            this.situacaoSelecionada = value;
            if (value > 0){          
                this.ListSinistros = this.ListSinistrosGeral.filter(x=> x.sstIdAtual == value);
            }
            else{
                this.ListSinistros = this.ListSinistrosGeral;
            }
          
        },
        onReady(editor)  {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        preprocessData(data) {
            return data.map(item => {
            return {
                ...item,
                proOrdem: parseInt(item.proOrdem),
            };
            });
        },
        formattedDate(value) {
            if (value!=null || value != ""){
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else{
                return "";
            }
           
        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        EditGrid(item) {
            this.$router.push('/sinistrocobrancadetalhe/' + item.pedIdCript);
        },
        montaGrid(){
            this.headers=[];
            this.headers.push({ text: "Contratacao", value: "pedId", sortable: true, });
            this.headers.push({ text: "Cliente", value: "pedDescricao", sortable: true, });
            this.headers.push({ text: "Data Inicial", value: "sncDtInclusao", sortable: true, });
            if (this.User.garid == 0){
                this.headers.push({ text: "Garantidora", value: "garNome", sortable: true, });
            }
            if (this.User.tpeid != 3){
            this.headers.push({ text: "Imobiliaria", value: "imoNome", sortable: true, });
            }

            this.headers.push({ text: "Situação", value: "scbNome", sortable: true, });
            this.headers.push({ text: 'Ações', value: 'actions' });
        },
        async Get() {
              await axios.get(`/Telas/ListaSinistrosCobranca/GetDados`)
                .then(response => {
                    this.ListSinistrosGeral = response.data.sinistros.sort(
                        (a, b) => (b.sntDtinclusao || '').localeCompare(a.sntDtinclusao || '')
                        );
                    this.ListSinistros = this.ListSinistrosGeral;
                    this.User.garid = response.data.garId;
                    this.User.tpeid = response.data.tpeId;

                    console.log('this.ListSinistrosGeral')
                    console.log(this.ListSinistrosGeral)
                 
                    this.montaGrid();
                });           
          
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style scoped>
.tabinfo{
    font-size:14px;
    text-transform: capitalize;
  }
.gp-claim-status-toolbar { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 14px; padding-bottom: 12px; border-bottom: 1px solid #e8e1d7; }
.gp-claim-status-button { min-height: 34px; padding: 6px 12px; border: 1px solid #d8d2c8; border-radius: 9px; background: #fff; color: #596579; font-size: 11px; font-weight: 700; transition: .18s ease; }
.gp-claim-status-button:hover { border-color: #e77900; color: #c96500; }
.gp-claim-status-button.is-active { border-color: #e77900; background: #e77900; color: #fff; box-shadow: 0 4px 10px rgba(231,121,0,.18); }
.gp-claim-entity-summary { display: flex; flex-direction: column; gap: 2px; line-height: 1.25; }
.gp-claim-entity-summary strong { color: #17223b; font-size: 10.5px; }
.gp-claim-entity-summary small { color: #718096; font-size: 9.5px; }
@media(max-width:767.98px){.gp-claim-status-toolbar{display:grid;grid-template-columns:repeat(2,minmax(0,1fr))}.gp-claim-status-button{width:100%}}
</style>
